// Vendor JS
import Debug from 'debug';

class CommentActions {
	init() {
		try {
			Debug(`cig:info:sage:class:CommentActions`)(`init start`);
			this.addAllHandlers();

		} catch (err) {
			Debug(`cig:error:sage:class:CommentActions`)(`init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}

	/**
	 * Comment Reply Handler
	 *
	 * @param event {object}
	 *
	 * @return {boolean}
	 */
	commentReply = event => {
		event.preventDefault();

		const replyLinkElement = event.target || event.srcElement;
		const currentCommentForm = document.getElementById((`form-comment-${replyLinkElement.getAttribute('data-comment-id')}`));

		/* Hide main comment form header */ // @TODO there must be a way to select all forms?
		const mainCommentFormDivs = document.querySelectorAll('.comment-form-main,.comment-from');
		/* Hide all except main comment form header */
		const allCommentFormDivs = document.getElementsByClassName('comment-form');

		// Hide all comment form divs
		Array.from(allCommentFormDivs).forEach(element => {
			element.style.display = `none`;
		});

		// Hide all comment form divs
		Array.from(mainCommentFormDivs).forEach(element => {
			element.style.display = `none`;
		});

		/* Show current comment form and move cursor into text box */
		if (currentCommentForm) {
			currentCommentForm.parentNode.style.display = `block`;
			currentCommentForm.querySelector('textarea').focus();
		}

		return false;
	};

	/**
	 * Add event Handlers for comment reply buttons
	 */
	addCommentReplyReplyHandlers = () => {
		try {
			Array.from(document.getElementsByClassName('comment-reply-link'))
				.forEach(link => link.addEventListener('click', this.commentReply));

		} catch (err) {
			Debug(`cig:error:sage:class:CommentActions`)(`addCommentReplyHandlers Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

	/**
	 * Comment Guidelines Handler
	 *
	 * @param event
	 *
	 * @return {boolean}
	 */
	toggleCommentGuidelines = event => {
		event.preventDefault();

		// const commentGuidelinesLinkElement = event.target || event.srcElement;
		const commentGuidelineRules = document.querySelector('#comment-guidelines-rules');

		// Toggle showing or hiding the element
		if (window.getComputedStyle(commentGuidelineRules).display === 'block') {
			commentGuidelineRules.style.display = `none`;
		} else {
			commentGuidelineRules.style.display = `block`;
		}

		return false;
	};

	/**
	 * Add comment guidelines event handler
	 */
	addCommentGuidelinesHandler = () => {
		try {
			const commentGuidelinesButton = document.getElementById('comment-guidelines-toggle');

			// Apply Event Listener
			if (commentGuidelinesButton) {
				commentGuidelinesButton.addEventListener('click', this.toggleCommentGuidelines);
			}

		} catch (err) {
			Debug(`cig:error:sage:class:CommentActions`)(`addCommentGuidelinesHandler Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

	/**
	 * Cancel comment event handler (applies to main and reply forms)
	 *
	 * @param event
	 */
	cancelCommentReply = event => {
		const cancelCommentReplyButtonElement = event.target || event.srcElement;

		// Hide the closest open form
		const closestCommentForm = cancelCommentReplyButtonElement.closest('.comment-form');
		closestCommentForm.style.display = `none`;

		/* If the reply is canceled show the main form again */
		const mainCommentFormDivs = document.querySelectorAll('.comment-form-main,.comment-from');

		// Loop through all comment form containers
		Array.from(mainCommentFormDivs).forEach(formElement => {
			// Show element
			formElement.style.display = `block`;

			if (formElement.querySelector('.comment-form')) {
				formElement.querySelector('.comment-form').style.display = `block`;
			}
		});
	};

	/**
	 * Add comment reply cancel event handlers to cancel buttons
	 */
	addCommentReplyCancelHandlers = () => {
		try {
			Array.from(document.getElementsByClassName('comment-reply-cancel'))
				.forEach(button => button.addEventListener('click', this.cancelCommentReply));

		} catch (err) {
			Debug(`cig:error:sage:class:CommentActions`)(`addCommentReplyCancelHandlers Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

	/**
	 * Focus text area if comment link is clicked  -- TODO: this isn't focusing properly
	 * https://stackoverflow.com/questions/10593111/focus-on-textarea-based-from-anchor-link
	 */
	newCommentLinkHandler = event => {
		document.getElementById('form-comment-main').querySelector('textarea').focus();
	};

	/**
	 * Add new comment link event handler
	 */
	addNewCommentLinkHandler = () => {
		try {
			const newCommentLink = document.getElementById('main-comment-form-link');

			if (newCommentLink) {
				newCommentLink.addEventListener('click', this.newCommentLinkHandler);
			}

		} catch (err) {
			Debug(`cig:error:sage:class:CommentActions`)(`addNewCommentLinkHandlers Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

	/**
	 * Add all Event Listeners
	 */
	addAllHandlers = () => {
		this.addCommentReplyReplyHandlers();
		this.addCommentGuidelinesHandler();
		this.addCommentReplyCancelHandlers();
		this.addNewCommentLinkHandler();
	};
}

export default new CommentActions();
